import { useCallback, useEffect, useState } from 'react'
import { useBulkActionContext } from '../../../BulkActionContext'
import { ErrorSummary, ValidationCallback } from '../typings'
import { formatErrors } from '../functions'
import { produce } from 'immer'
import { BulkUpdateStatusDTO } from '../../../typings'

export const useValidateRows = (validateRows: ValidationCallback) => {
  const {
    selectedRows,
    dispatch,
    state: { isValidating },
  } = useBulkActionContext()

  const updateState = useCallback(
    (dto?: BulkUpdateStatusDTO) => {
      const { errors, hasAlreadyClosed, hasUnableToClose } = formatErrors(dto)

      dispatch({ type: 'setErrors', payload: errors })
      setErrorSummary((prev) =>
        produce(prev, (draft) => {
          draft.count = errors.size
          draft.hasAlreadyClosed = hasAlreadyClosed
          draft.hasUnableToClose = hasUnableToClose
        }),
      )
    },
    [dispatch],
  )

  const [errorSummary, setErrorSummary] = useState<ErrorSummary>({
    count: 0,
    hasAlreadyClosed: false,
    hasUnableToClose: false,
  })

  useEffect(() => {
    let mounted = true

    const doValidation = async () => {
      dispatch({ type: 'startValidating' })
      const dto = await validateRows({
        Ids: selectedRows.map((x) => Number(x)),
      })
      if (mounted) updateState(dto)
    }

    if (selectedRows.length > 0) doValidation()
    else updateState()

    return () => {
      mounted = false
    }
  }, [dispatch, selectedRows, updateState, validateRows])

  return {
    errorSummary,
    loading: isValidating,
  }
}
